import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, resolveDirective as _resolveDirective, openBlock as _openBlock, createBlock as _createBlock, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("h4", { class: "fw-bold" }, "Afiliaciones", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_descriptions_item = _resolveComponent("el-descriptions-item")!
  const _component_el_descriptions = _resolveComponent("el-descriptions")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_drawer = _resolveComponent("el-drawer")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createBlock(_component_el_drawer, {
    modelValue: _ctx.drawerOption,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.drawerOption) = $event)),
    direction: "ltr",
    size: "60%",
    resizable: ""
  }, {
    header: _withCtx(() => [
      _hoisted_1
    ]),
    default: _withCtx(() => [
      _createVNode(_component_el_descriptions, {
        column: 1,
        size: "default",
        border: ""
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_descriptions_item, { label: "Alias" }, {
            default: _withCtx(() => [
              _createTextVNode("COLLEGE")
            ]),
            _: 1
          }),
          _createVNode(_component_el_descriptions_item, { label: "Institución" }, {
            default: _withCtx(() => [
              _createTextVNode("ASOCIACION CULTURAL DEPORTIVA PERU TAEKWONDO COLLEGE")
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _withDirectives((_openBlock(), _createBlock(_component_el_table, {
        data: _ctx.listAfiliations,
        border: "",
        "table-layout": 'auto',
        "scrollbar-always-on": true,
        class: "mt-5",
        "header-cell-class-name": "text-black bg-secondary text-uppercase text-center"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_table_column, {
            prop: "idinstitution",
            label: "ID",
            width: "80",
            align: "center"
          }),
          _createVNode(_component_el_table_column, {
            label: _ctx.t('tipo')
          }, null, 8, ["label"]),
          _createVNode(_component_el_table_column, {
            label: _ctx.t('dateStart')
          }, null, 8, ["label"]),
          _createVNode(_component_el_table_column, {
            label: _ctx.t('dateEnd')
          }, null, 8, ["label"]),
          _createVNode(_component_el_table_column, {
            label: _ctx.t('state')
          }, null, 8, ["label"])
        ]),
        _: 1
      }, 8, ["data"])), [
        [_directive_loading, _ctx.loader]
      ])
    ]),
    _: 1
  }, 8, ["modelValue"]))
}